type Props = {
  value: string
  onChange: (value: string) => void
  label?: string
}

export default function TextInput({ value, onChange, label }: Props) {
  return (
    <div className="w-full">
      {label && (
        <label className="block font-medium mb-2">{label}</label>
      )}

      <textarea
        className="w-full border rounded p-3 min-h-[150px]"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}